<template>
    <div v-if="ay_list != null">
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Add Receivable Amount</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container>
                <v-row dense justify="center">
                    <v-col cols="12" sm="5" md="5" style="text-align: left;">
                        <v-combobox rounded dense required v-model="standard" return-object :items="standard_list"
                            item-text="standard" label="Select Standard" outlined />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="5" md="5" style="text-align: right;">
                        <v-combobox rounded dense required return-object v-model="from_ay" :items="ay_list"
                            item-text="ay" label="From Academic Year" outlined />
                    </v-col>
                    <v-col cols="12" sm="2" md="2" style="text-align: center;">
                        <v-btn text color="#0f2027" :loading="copy_btn_load">
                            <v-icon large color="#0f2027">mdi-arrow-right-bold-circle</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="5" md="5" style="text-align: left;">
                        <v-combobox rounded dense required v-model="to_ay" return-object :items="ay_list" item-text="ay"
                            label="To Academic Year" outlined />
                    </v-col>
                </v-row>
                <v-row dense justify="center">
                    <v-btn v-if="standard && to_ay" class="button" @click="getStudent()">Fetch</v-btn>
                </v-row>
            </v-container>
        </v-card>

        <v-card class="box" v-if="stud_list != ''">
            <v-data-table v-model="selectedTasks" item-key="lid" :single-select="singleSelect" show-select
                :headers="headers" :items="bookList1" dense sort-by="" class="elevation-1 mytable" :search="search"
                @current-items="getFiltered">
                <template v-slot:top class="pb-5">
                    <v-row justify="center" align="center">
                        <tr class="t-row">
                            <div>
                                <th>
                                    <v-row>
                                        <span v-for="header in headers" :key="header.text">
                                            <span v-if="filters.hasOwnProperty(header.value)">
                                                <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small rounded
                                                    dense outlined color="#0F2027" :label="header.text" multiple
                                                    clearable :items="columnValueList(header.value)"
                                                    v-model="filters[header.value]"></v-autocomplete>
                                            </span>
                                        </span>
                                    </v-row>
                                    <v-text-field @change="addremark" dense rounded outlined v-model="remark"
                                        label="Enter Remark"></v-text-field>
                                </th>
                            </div>
                        </tr>
                    </v-row>

                </template>

                <template v-slot:item.remark="{ item }">
                    <!-- {{ item.remark }} -->
                    <v-text-field dense rounded outlined v-model="item.remark" label="Enter Remark"></v-text-field>
                </template>
                <template v-slot:item.isactive="{ item }">
                    <span v-if="item.isactive">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>
            </v-data-table>
            <v-row dense justify="center">
                <v-btn :loading="copy_offer_btn_load" class="button" @click="addAmount()">Add Receivable Amount From
                    {{ from_ay.ay }}
                    To {{ to_ay.ay }}</v-btn>
            </v-row>
        </v-card>
        <v-dialog v-model="dialog" persistent max-width="1500px">
            <v-card>
                <v-container>
                    <v-card class="box">
                        <!-- {{status_list}} -->
                        <v-row dense>
                            <v-col cols="12" sm="6" md="6">
                                <v-btn rounded color="success" outlined @click="
                                    fnExcelReport('my-table-id', 'Receivable_Fee_Status')
                                    " :loading="loader">
                                    <v-icon color="success">mdi-export</v-icon>Export
                                </v-btn>
                            </v-col>
                        </v-row>
                        <div id="my-table-id">
                            <v-data-table :headers="headers_1" :items="status_list" dense sort-by=""
                                class="elevation-1 mytable" :search="search"> </v-data-table>
                        </div>
                        <v-row justify="center">
                            <v-btn class="button" text @click="dialog = false">Close</v-btn>
                        </v-row>
                    </v-card>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
import axios from "axios";
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        ay_list: null,
        to_ay: null,
        from_ay: null,
        from_slot_list: null,
        to_slot_list: null,
        // extraBreadcrumbItems: [


        // ],
        // breadcrumbClass: "breadcrumb-style1",
        search: "",
        copy_btn_load: false,
        standard_list: [],
        singleSelect: false,
        selectedTasks: [],
        standard: null,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        overlay: false,
        filterArr: [],
        status_list: [],
        dialog: false,
        remark: null,
        copy_offer_btn_load: false,
        filters: {
            registration_number: [],
            standard: [],
        },
        stud_list: [],
        headers: [
            { text: "Student Name", value: "name" },
            { text: "Registration_number", value: "registration_number" },
            { text: "Standard", value: "standard" },
            { text: "Division", value: "division" },
            { text: "Balance Fee", value: "balance" },
            { text: "Remark", value: "remark" },
        ],
        headers_1: [
            { text: "Student Name", value: "name" },
            { text: "Registration_number", value: "registration_number" },
            { text: "Status", value: "status" },
        ],
    }),
    computed: {
        bookList1() {
            return this.stud_list.filter((d) => {
                return Object.keys(this.filters).every((f) => {
                    return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                });
            });
        },
    },
    methods: {
        addremark() {
            for (var i = 0; i < this.stud_list.length; i++) {
                this.stud_list[i].remark = this.remark
            }
        },
        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table border='1px'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

            //Save the file
            // var blob = new Blob([tab_text], {
            //     type: "application/vnd.ms-excel;charset=utf-8",
            // });
            // window.saveAs(blob, fileName);
            const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const filename = name + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        getFiltered(e) {
            this.filterArr = e;
        },
        columnValueList(val) {
            return this.stud_list.map((d) => d[val]);
        },
        onLoad() {
            axios
                .post("/Examination/getInitialData")
                .then((res) => {
                    // this.to_ay = res.data.curreny_ay;
                    this.ay_list = res.data.ay_list;
                    // this.from_ay = res.data.curreny_ay;
                    this.standard_list = res.data.standardlist;
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => {
                    //close loader
                    this.copy_offer_btn_load = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        addAmount() {
            if (this.selectedTasks == "") {
                this.showSnackbar("#b71c1c", "Please select Subject");
            }
            this.copy_offer_btn_load = true;
            const data = {
                lid: this.selectedTasks,
                from_ay: this.from_ay.id,
                to_ay: this.to_ay.id,
                standard: this.standard.id,
            };
            axios
                .post("/AccountingAndFees/addAmount", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.status_list = res.data.status_list;
                        this.dialog = true;
                        this.showSnackbar("#4caf50", "Receivable Amount Added Successfully...");
                        this.stud_list = [];
                        this.singleSelect = false;
                        this.selectedTasks = [];
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.smsg);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.copy_offer_btn_load = false;
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => {
                    //close loader
                    this.copy_offer_btn_load = false;
                    this.stud_list = [];
                    this.singleSelect = false;
                    this.selectedTasks = [];
                    this.standard = null;
                    this.to_ay = null;
                    this.from_ay = null;
                });
        },
        getStudent() {
            if (this.from_ay.id == this.to_ay.id) {
                this.showSnackbar("#b71c1c", "From and To Academic year cannot be same!!!...");
                return;
            }
            const formData = {
                from_ay: this.from_ay.id,
                standard: this.standard.id,
            };
            this.overlay = true;
            axios
                .post("/AccountingAndFees/getStudent", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.stud_list = res.data.stud_list;
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
    },
    mounted() {
        this.onLoad();
    },
};
</script>
<style scoped></style>
